import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import moment from "moment";
import List from "../../editableGrid/list/list";
import {
  getWorkflowsAction,
  clearWorkflowsAction,
  searchWorkflowsAction,
  clearSearchWorkflowsAction,
  deleteWorkflowsAction,
  flushDeleteWorkflowsData,
} from "../../../store/actions/admin-workflows-actions";
import { updatefilterState } from "../../../store/actions/list-actions";
import {
  DEFAULT_SORT,
  DEFAULT_SEARCH,
  ROW_MIN_HEIGHT,
  MAX_ROW_HEIGHT,
  ROW_FIELD_NAMES,
  MORE_MENU_ACTION_NAME,
} from "./adminErrorLogConstants";
import {
  IPagination,
  getDefaultPaginationModel,
  getPaginationModel,
} from "../../../models/IPagination";
import ReadMore from "../../readMore/readMore";
import t from "../../../localization/en/translation.json";
import { AppIcon, AppModal } from "../../../theme";
import { AsyncTypeahead, ClearButton } from "react-bootstrap-typeahead";
import { search, trash } from "../../../theme/icons";
import { columnConfig } from "./columnConfig";
import { ICPSErrorLog } from "../../../models/ICPSErrorLog";
import { EWorkFlowTableName } from "../../../utils/Constants";
import { getStringWithBold, timeZoneAbbreviated } from "../../../utils/helper-utility";
import { MoreMenuOption } from "../../moreMenu/moreMenuOptions";
import MoreMenu from "../../moreMenu/moreMenu";
import "./adminErrorLog.scss";
import { IResponse, WFFields } from "../adminWorkflowConstant";
import AppNotification from "../../appNotification/appNotification";
import { ISSPUserAdminAccess } from "../../../models/IRoles";
import DOMPurify from 'dompurify';

type IProps = RouteComponentProps<any> & {
  adminWorkflowsData: ICPSErrorLog[];
  updatefilterState: Function;
  paginationDetails: IPagination;
  getWorkflowsAction: Function;
  clearWorkflowsAction: Function;
  clearSearchWorkflowsAction: Function;
  searchLoader: boolean;
  fetchSearchData: Function;
  searchData: ICPSErrorLog[];
  deleteWorkflowsAction: Function;
  flushDeleteWorkflowsData: Function;
  deleteAdminWorkflowsData: IResponse;
  userAdminAccess: ISSPUserAdminAccess;
  isAdminProjectPage: boolean;
  isProjectAdmin?: boolean;
};

interface IState {
  paginationPayload: IPagination;
  searchQuery: ICPSErrorLog[];
  showDeleteModal: boolean;
  selectedRow: ICPSErrorLog[];
  showNotification: boolean;
  notificationVariant: string;
  notificationMessage: string;
}

class AdminErrorLog extends Component<IProps, IState> {
  gridApi;
  typeahead;
  localTimeZoneAbbr = timeZoneAbbreviated();
  state = {
    paginationPayload: getPaginationModel({
      ...getDefaultPaginationModel(),
      sortDirection: DEFAULT_SORT.sort,
      sortColumn: DEFAULT_SORT.colId,
      totalRecords: 0,
      filters: [],
    }),
    searchQuery: [],
    showDeleteModal: false,
    selectedRow: [],
    showNotification: false,
    notificationVariant: "",
    notificationMessage: "",
  };

  componentDidMount() {
    this.getWorkflows();
    this.updateFilterState();
  }

  componentDidUpdate(prevProps, prevState) {
    const { paginationPayload } = this.state;
    if (prevState.paginationPayload !== paginationPayload) {
      this.getWorkflows();
      this.updateFilterState();
    }
    this.manageNotification(prevProps);
  }

  componentWillUnmount() {
    this.props.clearWorkflowsAction();
    this.props.clearSearchWorkflowsAction();
  }

  checkProjectAccess = () => {
    const { userAdminAccess, isAdminProjectPage, isProjectAdmin, match: { params: { id } } } = this.props;
    if (id) {
      return isProjectAdmin;
    } 
    return isAdminProjectPage ? (userAdminAccess.portalAdmin || userAdminAccess.portalAdminConsole) : userAdminAccess.portalAdmin;
  }

  getWorkflows = () => {
    const {
      match: {
        params: { id },
      },
    } = this.props;
    const { paginationPayload } = this.state;
    paginationPayload.id = id;
    paginationPayload.tableName = EWorkFlowTableName.WORKFLOW_ERROR_LOG;
    paginationPayload.apiURL = paginationPayload.tableName;
    if (id) {
      paginationPayload.apiURL = `${id}/${paginationPayload.apiURL}`;
    }
    this.props.getWorkflowsAction(paginationPayload);
  };

  onGridReady = ({ api }) => {
    this.gridApi = api;
   // api.resetRowHeights();    
  };

  handlePageNumberChange = (pageNumber) => {
    this.handlePagination({ pageNumber });
  };

  handlePageSizeChange = (pageSize) => {
    this.handlePagination({ pageSize, pageNumber: 1 });
  };

  handleRowHeight = ({ data }) => {  
    if (
      data[ROW_FIELD_NAMES.TITLE] &&
      data[ROW_FIELD_NAMES.WFR_ERR_STACK] &&
      data[ROW_FIELD_NAMES.WFR_ERR_STACK_SOURCE]
    ) {
      const largest = Math.max(
        data[ROW_FIELD_NAMES.TITLE].length,
        data[ROW_FIELD_NAMES.WFR_ERR_STACK].length,
        data[ROW_FIELD_NAMES.WFR_ERR_STACK_SOURCE].length
      );
      if (largest <= ROW_MIN_HEIGHT) {
        return ROW_MIN_HEIGHT;
      } else if (largest <= MAX_ROW_HEIGHT) {
        return largest;
      } else {
        return MAX_ROW_HEIGHT;
      }
    } else {
      return ROW_MIN_HEIGHT;
    }
  };

  handleSorting = (
    sortColumn = DEFAULT_SORT.colId,
    sortDirection = DEFAULT_SORT.sort
  ) => {
    const { paginationPayload } = this.state;

    if (
      paginationPayload.sortColumn === sortColumn &&
      paginationPayload.sortDirection === sortDirection
    ) {
      return;
    }

    const updatedPaginationPayload = {
      ...paginationPayload,
      sortColumn,
      sortDirection,
    };
    this.setState({ paginationPayload: updatedPaginationPayload });
  };

  handleFilterChange = (
    filters,
    sortColumn = DEFAULT_SORT.colId,
    sortDirection = DEFAULT_SORT.sort
  ) => {
    const { paginationPayload } = this.state;
    const updatedPayload = {
      ...paginationPayload,
      filters,
      sortColumn,
      sortDirection,
      pageNumber: 1,
    };

    this.setState({ paginationPayload: updatedPayload });
  };

  updateFilterState = () => {
    const {
      filters = [],
      sortDirection,
      sortColumn,
    } = this.state.paginationPayload;
    const isDefaultSort =
      sortDirection === DEFAULT_SORT.sort && sortColumn === DEFAULT_SORT.colId;
    const isClearAllDisabled = isDefaultSort && !filters.length;

    this.props.updatefilterState({
      filters,
      sortDirection,
      sortColumn,
      isClearAllDisabled,
    });
  };

  handlePagination = (paginationParams) => {
    const { paginationPayload } = this.state;
    const updatedPaginationPayload = {
      ...paginationPayload,
      ...paginationParams,
    };

    this.setState({ paginationPayload: updatedPaginationPayload });
  };

  renderReadMoreTextRows = ({ value }) => (
    <ReadMore title={t.admin_cps_error_log_read_more_title}>{value}</ReadMore>
  );

  renderDateRows = ({ value }) => {
    if (!value) {
      return "";
    }
    return (
      <span title={value}>{`${moment(value).format("MMM D, YYYY h:mm:ss a")} ${
        this.localTimeZoneAbbr
      }`}</span>
    );
  };

  handleSearchData = (query) => {
    const { paginationPayload } = this.state;
    if (
      paginationPayload &&
      paginationPayload.tableName
    ) {
      let searchUrl = paginationPayload.tableName;
      if (paginationPayload.id) {
        searchUrl = `${paginationPayload.id}/${searchUrl}`;
      }
      this.props.fetchSearchData({ query, searchUrl });
    }
  };

  handleSelectValue = (selectedArray) => {
    this.setState({
      ...this.state,
      searchQuery: selectedArray,
    });
  };

  clearSearch = () => {
    if (this.typeahead) {
      this.typeahead.clear();
    }
  };

  renderMenuItem = (option, props) => {
    const stringData = option[ROW_FIELD_NAMES.TITLE] + ", " + option[ROW_FIELD_NAMES.WFR_ERR_STACK_SOURCE];
    return (
      <div className="async-dropdown" title={stringData} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(getStringWithBold(stringData, props.text)) }}>
      </div>
    );
  };

  handleMoreMenuOptionClick = (actionName: string) => {
    if (actionName === MORE_MENU_ACTION_NAME.DELETE) {
      const rows = this.gridApi.getSelectedRows();
      this.setState({ showDeleteModal: true, selectedRow: rows[0] });
    }
  };

  renderMoreMenu = () => {
    const checkProjectAccessRole = this.checkProjectAccess();
    const options: MoreMenuOption[] = [
      {
        id: "1234",
        title: t.delete,
        icon: trash,
        actionName: MORE_MENU_ACTION_NAME.DELETE,
        isDisabled: !checkProjectAccessRole,
      },
    ];

    return (
      <MoreMenu
        controlId="more-menu-apps"
        optionClickFn={this.handleMoreMenuOptionClick}
        options={options}
        vertical
        leftPlacement
      />
    );
  };

  closeDeleteModal = () => {
    this.setState({ showDeleteModal: false });
  };

  deleteWorkflows = () => {
    const { selectedRow, paginationPayload } = this.state;
    if (
      selectedRow &&
      selectedRow[WFFields.id] &&
      paginationPayload &&
      paginationPayload.tableName
    ) {
      let deleteUrl = `${paginationPayload.tableName}/${selectedRow[WFFields.id]}`;
      if (paginationPayload.id) {
        deleteUrl = `${paginationPayload.id}/${deleteUrl}`;
      }
      this.props.deleteWorkflowsAction(deleteUrl);
    }
    this.setState({ showDeleteModal: false });
  };

  showNotification = (action: string, success: boolean) => {
    let notificationVariant = "";
    let notificationMessage = "";
    if (action === MORE_MENU_ACTION_NAME.DELETE) {
      notificationVariant = success ? "success" : "error";
      notificationMessage = success
        ? t.admin_cps_delete_success
        : t.admin_cps_delete_error;
    }

    this.setState({
      showNotification: true,
      notificationVariant,
      notificationMessage,
    });
    setTimeout(() => {
      if (this.state.showNotification) {
        this.setState({
          showNotification: false,
          notificationVariant,
          notificationMessage,
        });
      }
    }, 3000);
  };

  manageNotification = (prevProps) => {
    const { searchQuery } = this.state;
    const { deleteAdminWorkflowsData } = this.props;
    if (deleteAdminWorkflowsData !== prevProps.deleteAdminWorkflowsData) {
      if (deleteAdminWorkflowsData?.success) {
        this.showNotification(MORE_MENU_ACTION_NAME.DELETE, true);
        this.props.flushDeleteWorkflowsData();
        this.getWorkflows();
        if (searchQuery.length) {
          this.clearSearch();
          this.setState({ searchQuery: [] });
        }
      } else if (deleteAdminWorkflowsData?.error) {
        this.showNotification(MORE_MENU_ACTION_NAME.DELETE, false);
      }
    }
  };

  closeNotification = () => {
    this.setState({
      showNotification: false,
      notificationMessage: "",
      notificationVariant: "",
    });
  };

  renderNotification = () => {
    const { showNotification, notificationMessage, notificationVariant } =
      this.state;
    return (
      <>
        {showNotification && (
          <AppNotification
            message={notificationMessage}
            variant={notificationVariant}
            onCloseNotifcation={this.closeNotification}
          />
        )}
      </>
    );
  };

  render() {
    const { adminWorkflowsData, paginationDetails, searchLoader, searchData } =
      this.props;
    const { paginationPayload, searchQuery, showDeleteModal, selectedRow } =
      this.state;
    const rowData = searchQuery.length ? searchQuery : adminWorkflowsData;
    const currentPage = searchQuery.length ? 1 : paginationPayload.pageNumber;
    if (paginationDetails) {
      paginationPayload.totalRecords = paginationDetails.totalRecords;
      paginationPayload.totalRecordsWithoutFilter =
        paginationDetails.totalRecords ||
        paginationPayload.totalRecordsWithoutFilter;
    }
    if (searchQuery.length) {
      paginationPayload.totalRecords = searchQuery.length;
    }

    return (
      <div className={`error-log`}>
        <div className="search-wrapper">
          <div className="project-form-field">
            <AppIcon icon={search} />
            <AsyncTypeahead
              id="async-search"
              isLoading={searchLoader}
              filterBy={[DEFAULT_SEARCH.colId]}
              labelKey={(option) => `${option[DEFAULT_SEARCH.colId]}`}
              minLength={3}
              onSearch={this.handleSearchData}
              options={searchData}
              onChange={(selected) => this.handleSelectValue(selected)}
              placeholder={t.admin_cps_project_search}
              ref={(ref) => (this.typeahead = ref)}
              useCache={false}
              renderMenuItemChildren={(option, props) =>
                this.renderMenuItem(option, props)
              }
            >
              {({ onClear, selected }) => (
                <div className="rbt-aux">
                  {!!selected.length && <ClearButton onClick={onClear} />}
                </div>
              )}
            </AsyncTypeahead>
          </div>
        </div>
        <div className={`error-log-table`}>
          <List
            columnConfig={columnConfig}
            defaultColDef={defaultColDef}
            firstColumnBorderRight={true}
            rowData={rowData}
            paginate={true}
            withStickyScroll
            frameworkComponents={{
              cellRenderDateRows: this.renderDateRows,
              readMoreTextCellRender: this.renderReadMoreTextRows,
              moreMenuCellRenderer: this.renderMoreMenu,
            }}
            onGridReady={this.onGridReady}
            onSortChanged={this.handleSorting}
            currentPage={currentPage}
            pagination={paginationPayload}
            setItemsPerPage={this.handlePageSizeChange}
            onPageChange={this.handlePageNumberChange}
            onFilterChange={this.handleFilterChange}
            defaultSort={[DEFAULT_SORT]}
            getRowHeight={this.handleRowHeight}
          />
          <AppModal
            showModal={showDeleteModal}
            onModalClose={this.closeDeleteModal}
            onConfirm={this.deleteWorkflows}
            cancelBtnText={t.cancel}
            confirmBtnText={t.delete}
            title={t.admin_cps_modal_delete_title}
          >
            <div className="modal-content deleteModal">
              <div className="app-title-bold">
                <span className="app-modal-delete-body">
                  {t.admin_apps_modal_delete_body}{" "}
                </span>
                <span className="red-highlighted">{t.delete} </span>
                <span>{selectedRow && selectedRow[WFFields.title]}? </span>
              </div>
            </div>
          </AppModal>
          {this.renderNotification()}
        </div>
      </div>
    );
  }
}
const defaultColDef = {
  resizable: false,
  // Add other default properties that you want to apply to all columns
};
const mapStateToProps = ({ workflowsReducer }) => {
  return {
    adminWorkflowsData: workflowsReducer.adminWorkflowsData,
    paginationDetails: workflowsReducer.paginationDetails,
    searchLoader: workflowsReducer.searchLoader,
    searchData: workflowsReducer.searchData,
    deleteAdminWorkflowsData: workflowsReducer.deleteAdminWorkflowsData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getWorkflowsAction: (payload) => {
      dispatch(getWorkflowsAction(payload));
    },
    updatefilterState: (payload) => {
      dispatch(updatefilterState(payload));
    },
    clearWorkflowsAction: () => {
      dispatch(clearWorkflowsAction());
    },
    fetchSearchData: (payload) => {
      dispatch(searchWorkflowsAction(payload));
    },
    clearSearchWorkflowsAction: () => {
      dispatch(clearSearchWorkflowsAction());
    },
    deleteWorkflowsAction: (payload) => {
      dispatch(deleteWorkflowsAction(payload));
    },
    flushDeleteWorkflowsData: () => {
      dispatch(flushDeleteWorkflowsData());
    },
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AdminErrorLog)
);
